import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { DesktopHeaderConfig } from '@/features/newHome/domain/models/NewHomePageData';

interface MobileHeaderState {
  bgColor: string;
  logoColor: string;
}

interface HeaderConfigState {
  mobile: MobileHeaderState;
  desktop: DesktopHeaderConfig;
}

const DEFAULT_MOBILE: MobileHeaderState = {
  bgColor: '#ffffff',
  logoColor: '#011E39',
};

/** Defaults for all routes; new home can override via `desktopHeader` in page JSON (see `adaptDesktopHeaderDtoToDomain`). */
export const DEFAULT_DESKTOP_HEADER: DesktopHeaderConfig = {
  topBarBg: '#ffffff',
  mainBarBg: '#ffffff',
  headerBottomBorderColor: 'rgba(229, 231, 235, 0.6)',
  headerTextColor: '#011E38',
  /** Desktop `DesktopNavbar` strip — override with JSON `desktopHeader.navbarBg` on new home load. */
  navbarBg: '#011E38',
  navbarLinkColor: '#ffffff',
  searchBg: '#ffffff',
  /** Match `desktopHeader.searchBorderColor` in newHome JSON — white blends into `searchBg` and hides the pill on PLP/other routes. */
  searchBorderColor: '#011E38',
  searchTextColor: '#111827',
  searchPlaceholderColor: '#9ca3af',
  searchIconColor: '#9ca3af',
  layout: 'fluid',
};

const initialState: HeaderConfigState = {
  mobile: DEFAULT_MOBILE,
  desktop: DEFAULT_DESKTOP_HEADER,
};

const headerConfigSlice = createSlice({
  name: 'headerConfig',
  initialState,
  reducers: {
    setMobileHeaderConfig(state, action: PayloadAction<MobileHeaderState>) {
      state.mobile = action.payload;
    },
    resetMobileHeaderConfig(state) {
      state.mobile = DEFAULT_MOBILE;
    },
    setDesktopHeaderConfig(state, action: PayloadAction<DesktopHeaderConfig>) {
      state.desktop = action.payload;
    },
    resetDesktopHeaderConfig(state) {
      state.desktop = DEFAULT_DESKTOP_HEADER;
    },
  },
});

export const {
  setMobileHeaderConfig,
  resetMobileHeaderConfig,
  setDesktopHeaderConfig,
  resetDesktopHeaderConfig,
} = headerConfigSlice.actions;
export const headerConfigReducer = headerConfigSlice.reducer;
